import { Injectable, inject } from '@angular/core';
import { Request } from '@core/models/requests.model';
import { DataProspect } from '@core/interfaces/catalogos.intefaces';

@Injectable({
  providedIn: 'root',
})
export class DataProspectService {
  private url = `ventas/datos-prospectos/search`;
  private readonly request = inject(Request);

  getDataProspect(idProspecto: string) {
    const body = {
      configuracion: this.request.getConfigUser(),
      idProspecto: idProspecto,
    };
    const options = {
      headers: this.request.headers,
    };
    return this.request.Post<DataProspect>(`${this.url}`, body, options);
  }
}
